module.exports = __webpack_public_path__ + "media/images/icons/outlined/facebook-63da45b75eb103351fc140b769d08063.svg";